import { screenSizeDetection as k, useGlobalStore as g, componentUtils as s, getCmsProperty as o, contentByLabel as p } from "@sunrise/shared";
import { defineComponent as L } from "vue";
import l from "./index30.js";
import C from "./index146.js";
import M from "./index565.js";
import y from "./index160.js";
import A from "./index161.js";
import w from "./index566.js";
import x from "./index567.js";
import F from "./index568.js";
const D = L({
  name: "MsFooter",
  components: {
    MsBreadcrumb: C,
    CsLink: l,
    MsFooterLink: y,
    MsFooterPrivacyLink: A,
    MsFacebook: x,
    MsInstagram: w,
    MsYoutube: F,
    MsLogo: M
  },
  props: {
    cmsContent: {
      type: Object,
      required: !0
    },
    footerLinks: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { isScreenM: i } = k(), a = g().privacyManagerId;
    function m() {
      return r().breadcrumb && r().breadcrumb.length > 0 && r().breadcrumbHidden !== !0;
    }
    function r() {
      return e.cmsContent;
    }
    function c() {
      const t = e.footerLinks, n = [];
      return t.jobsAtMeinestadt && n.push({
        href: t.jobsAtMeinestadt,
        txt: "Karriere"
      }), t.companyPage && n.push({
        href: t.companyPage,
        txt: "Unternehmen"
      }), e.cmsContent.pressLink && n.push({
        href: e.cmsContent.pressLink,
        txt: "Presse"
      }), t.advertisingHomepage && n.push({
        href: t.advertisingHomepage,
        txt: "Werbung schalten"
      }), t.sitemapPage && n.push({
        href: t.sitemapPage,
        txt: "Übersicht Rubriken"
      }), n;
    }
    function u() {
      return [
        {
          href: e.cmsContent.agbLink,
          txt: "AGB"
        },
        {
          href: e.cmsContent.privacyLink,
          txt: "Datenschutz"
        },
        {
          href: e.cmsContent.imprintLink,
          txt: "Impressum"
        }
      ];
    }
    function f() {
      return o("meinestadt/frame#showSocialLinks", e.cmsContent, !1);
    }
    function h() {
      return o("meinestadt/frame#showAppLinks", e.cmsContent, !1);
    }
    function b() {
      return o("meinestadt/frame#showFooter", e.cmsContent, !1);
    }
    function d() {
      return !!p(e.cmsContent.page, "E_Footer_Awards");
    }
    return {
      showFooter: b,
      showAppLinks: h,
      showSocialLinks: f,
      getSocketLinks: u,
      getAboutLinks: c,
      getFooter: r,
      getChildren: s.getChildren,
      isScreenM: i,
      privacyManagerId: a,
      createAssetLink: s.createAssetLink,
      showAwards: d,
      hasBreadcrumb: m
    };
  }
});
export {
  D as default
};
